export function toBool(value) {
  return value === 'true';
}

export function parseBoolFields(row, fields) {
  fields.forEach(field => {
    row[field] = toBool(row[field]);
  });
  return row;
}

export function parseBoolRows(rows, fields) {
  return (rows || []).map(row => parseBoolFields(row, fields));
}
